import Sanjay from '../assets/Sanjay_profile_photo.jpg';
import resume from '../assets/resume.pdf';
// import linkedin from '../assets/linkedin.png';

export default function About() {
    return (
        <>
        <div className="container-fluid row bg-primary" style={{minHeight:'250px'}}>
            <div className="col-lg-3 text-white p-5 ms-5 text-lg-end">
                <span className="headText">About Us</span>
            </div>
            <div className="col-lg font-weight-light p-5 me-lg-5 ms-lg-5 text-white">
                <div className="bodyTextNP text-white">
                    Here at Finance & Technology Consultants, Inc, we are dedicated to you and all your different accounting needs.
                    We've been around for over 25 years and we've won several awards for the best accountant firm.
                    But, our most important win is making you a happy, life-long customer.
                    </div>
            </div>
        </div>
        <div className="container-fluid row bg-light">
            <div className="col-lg-1 col-sm-0"></div>
            <div className="col-lg-5 text-dark pt-5 pb-5">
                <span className="headText">Meet The Team</span>
            </div>
            <div className="col-lg-5 h4 text-end font-weight-light">
            </div>
        </div>

        <div className="container-fluid ps-5 row bg-light pb-5">
            <div className="col-lg-1 col-sm-0"></div>
            <div className="col-lg-3 text-black text-center">
                <a href={resume} target='_blank' rel="noreferrer">
                    <img src={Sanjay} alt="Sanjay Arora" className='profileImage'/>
                </a>
                <div className="profileName text-dark text-center">Sanjay Arora</div>
                <div className="profileDes text-dark text-center">Founder</div>
            </div>
            <div className="col-lg-7 bodyTextNP ms-lg-5 ps-lg-5">
            For the past 30 plus years, I have been involved in Accounting, Taxation, Business Consulting, 
            Entrepreneurship, Financial Consulting, Investments, Technology, and Telecom Consulting.  
            Ever since I migrated to the USA in 1988 with an accounting degree, I have gravitated to the world of Finance and Taxation. 
            During my journey, I was fortunate to meet various businesses, non-profit organizations, 
            homeowner’s associations, and individuals that allowed me to expand my experiences in all the above-mentioned fields. 
            However, I was always loyal to my core talent of accounting, taxation, and finance. As an entrepreneur, 
            I expanded my business to include Technology & Telecom Consulting Company, a Real Estate Investment Company, and an Insurance Agency. 
             Over the years, I have shared my knowledge & guided many new and seasoned entrepreneurs.  
             I have also been involved in local non-profit organizations to achieve their goals and missions over the years. 
             Current involvement includes “Show and Heal”, an educational Non-Profit and “Palm Beach India Association”, South Florida Association 
             for people of Indian Origins. <br />
                To Know More About Sanjay, Click <a href={resume} target='_blank' rel="noreferrer">Here</a> <br />
                {/* <a href="https://www.linkedin.com/in/punjabimunda/" target='_blank' rel="noreferrer">
                    <img src={linkedin} className="linkedinIcon" alt='LinkedIn' />
                </a> */}
            </div>
        </div>
        </>
    );
}